import React from 'react';
import { Box, Breadcrumbs } from '@mui/material';
import { generatePath, matchPath, Link as RouterLink, useLocation } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';
import { StyledRescuerBreadcrumb, StyledRescuerTextBreadcrumb } from '../../Components/StyledRescuerBreadcrumb';
import routes from '../../../../../routes';

const EventsBreadcrumb = () => {
  const location = useLocation();

  const isShiftManagerPath = matchPath(location.pathname, {
    path: routes.mobileDashboardEventShiftManager,
  });

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={RouterLink}
          to={generatePath(routes.mobileDashboard)}
          label="Home"
          icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
        />
        {!isShiftManagerPath && <StyledRescuerTextBreadcrumb component="a" href="#" label="Events" />}
        {isShiftManagerPath && (
          <StyledRescuerTextBreadcrumb component={RouterLink} to={location?.state?.prevPath} label="Event detail" />
        )}
        {isShiftManagerPath && <StyledRescuerTextBreadcrumb component="p" label="Shift Manager" />}
      </Breadcrumbs>
    </Box>
  );
};

export default EventsBreadcrumb;
